import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H8.25C9.04565 3 9.80871 3.31607 10.3713 3.87868C10.9339 4.44129 11.25 5.20435 11.25 6V8.25C11.25 9.04565 10.9339 9.80871 10.3713 10.3713C9.80871 10.9339 9.04565 11.25 8.25 11.25H6C5.20435 11.25 4.44129 10.9339 3.87868 10.3713C3.31607 9.80871 3 9.04565 3 8.25V6ZM12.75 6C12.75 5.20435 13.0661 4.44129 13.6287 3.87868C14.1913 3.31607 14.9544 3 15.75 3H18C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V8.25C21 9.04565 20.6839 9.80871 20.1213 10.3713C19.5587 10.9339 18.7956 11.25 18 11.25H15.75C14.9544 11.25 14.1913 10.9339 13.6287 10.3713C13.0661 9.80871 12.75 9.04565 12.75 8.25V6ZM3 15.75C3 14.9544 3.31607 14.1913 3.87868 13.6287C4.44129 13.0661 5.20435 12.75 6 12.75H8.25C9.04565 12.75 9.80871 13.0661 10.3713 13.6287C10.9339 14.1913 11.25 14.9544 11.25 15.75V18C11.25 18.7956 10.9339 19.5587 10.3713 20.1213C9.80871 20.6839 9.04565 21 8.25 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7956 3 18V15.75ZM12.75 15.75C12.75 14.9544 13.0661 14.1913 13.6287 13.6287C14.1913 13.0661 14.9544 12.75 15.75 12.75H18C18.7956 12.75 19.5587 13.0661 20.1213 13.6287C20.6839 14.1913 21 14.9544 21 15.75V18C21 18.7956 20.6839 19.5587 20.1213 20.1213C19.5587 20.6839 18.7956 21 18 21H15.75C14.9544 21 14.1913 20.6839 13.6287 20.1213C13.0661 19.5587 12.75 18.7956 12.75 18V15.75Z"
        fill={colorValue}
      />
    </svg>
  );
};
